import { Media, MediaGroup, MediaType, PlayerPost, Prompt, VideoProjectDetail } from "@/interfaces";

export interface SharedPostFlowDefaults {
  promptId?: string | number;
  message?: string;
  mediaGroup?: MediaGroup;
  hashtags?: string;
  addShortLink?: boolean;
  addDisclaimer?: boolean;
  addDefaultHashtags?: boolean;
  showVideoTypeSelector?: boolean;
  initialScript?: string;
}

export const fromPrompt = (prompt: Prompt): SharedPostFlowDefaults => {
  return {
    promptId: prompt.promptId,
    message: prompt.message,
    mediaGroup: prompt.post,
    hashtags: prompt.hashtags,
    addShortLink: prompt.allowShortLink,
    addDisclaimer: prompt.allowComplianceDisclaimer,
    addDefaultHashtags: prompt.allowHashtags,
  };
};

export const fromVideoProject = (videoProject: VideoProjectDetail): SharedPostFlowDefaults => {
  return {
    message: videoProject.messageToPost || "",
    mediaGroup: videoProject.editedMedia,
    hashtags: videoProject.post?.hashtags || "",
    addDisclaimer: videoProject.allowComplianceDisclaimer,
    addShortLink: videoProject.allowShortLink,
    addDefaultHashtags: videoProject.allowPlayerHashtags,
  };
};

export const fromPlayerPost = (playerPost: PlayerPost, prompt?: Prompt) => {
  return {
    promptId: playerPost.promptId || prompt?.promptId,
    message: playerPost.message || prompt?.message || "",
    mediaGroup: playerPost.mediaGroup || prompt?.post || undefined,
    hashtags: playerPost.hashtags || prompt?.hashtags || "",
    addShortLink: prompt?.allowShortLink,
    addDisclaimer: prompt?.allowComplianceDisclaimer,
    addDefaultHashtags: prompt?.allowHashtags,
  };
};

export const fromMedia = (media: Media | undefined, secondsRecorded?: number, initialScript?: string) => {
  if (!media) return {};

  let type: MediaType = media.category;
  let showVideoTypeSelector = false;
  if (secondsRecorded && secondsRecorded > 89) {
    type = "VIDEO";
  } else if (secondsRecorded) {
    showVideoTypeSelector = true;
    type = "REELS";
  }
  return {
    showVideoTypeSelector,
    initialScript,
    mediaGroup: {
      type: type,
      media: [media],
    },
  };
};
